var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showing),expression:"showing"}],staticClass:"toast-wrapper"},[_c('span',{staticClass:"toast-content",domProps:{"innerHTML":_vm._s(_vm.message)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }